const root = document.body.appendChild(document.createElement('div'));
export default root;
